import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { FilterType, IFilters } from '@homeviews/models'

export const GUIDES_FEATURE_KEY = 'guides'

// todo
type GuidesState = {
  filters: IFilters
  activeGuide: any
  selections: number[]
}

const initialGuidesState: GuidesState = {
  filters: {},
  activeGuide: null,
  selections: [],
}

export const guideSlice = createSlice({
  name: GUIDES_FEATURE_KEY,
  initialState: initialGuidesState,
  reducers: {
    setActiveGuide: (
      state,
      { payload: { resource } }: PayloadAction<{ resource?: any }>,
    ) => {
      state.activeGuide = resource
    },
    setGuidesFilter: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: FilterType; value: any }>,
    ) => {
      const currentFilters = state.filters
      if (!value) {
        delete currentFilters[filter]
        state.filters = {
          ...currentFilters,
        }
      } else {
        state.filters = {
          ...state.filters,
          [filter]: value,
        }
      }
    },
    setBulkGuidesFilter: (
      state,
      { payload }: PayloadAction<{ filter: FilterType; value: any }[]>,
    ) => {
      let currentFilters = state.filters
      payload.forEach(({ filter, value }) => {
        if (!value) {
          delete currentFilters[filter]
        } else {
          currentFilters = {
            ...currentFilters,
            [filter]: value,
          }
        }
      })
      state.filters = currentFilters
    },
    selectGuideItem: (state, { payload }) => {
      state.selections = [...state.selections, payload]
    },
    unselectGuideItem: (state, { payload }) => {
      const newSelections = state.selections.filter((item) => item !== payload)
      state.selections = newSelections
    },
    clearGuidesSelections: (state) => {
      state.selections = []
    },
    clearGuidesFilters: (state) => {
      state.filters = {}
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const guidesReducer = guideSlice.reducer

export const {
  setGuidesFilter,
  setBulkGuidesFilter,
  clearGuidesFilters,
  setActiveGuide,
  selectGuideItem,
  unselectGuideItem,
  clearGuidesSelections,
} = guideSlice.actions

export const getGuidesState = (rootState): GuidesState =>
  rootState[GUIDES_FEATURE_KEY]

export const selectGuidesFilters = (rootState) =>
  rootState[GUIDES_FEATURE_KEY]?.filters

export const selectActiveGuide = (rootState): number =>
  rootState[GUIDES_FEATURE_KEY]?.activeRes
